<template>
  <FloatLabel variant="on" class="chat-widget__domain-filter chat-widget__w-100">
    <div class="chat-widget__domain-filter-wrapper">
      <div class="chat-widget__domain-filter-input-wrapper">
        <InputText
            type="text"
            class="chat-widget__domain-filter-input"
            inputId="on_domain_filter"
            v-model="userInput.searchDomainFilter"
        />
        <i v-if="userInput.searchDomainFilter"
           class="pi pi-times chat-widget--cursor-pointer chat-widget__domain-filter--clear"
           @click="clearInput"/>
      </div>
      <i class="pi pi-info-circle chat-widget--cursor-pointer"
         v-tooltip.bottom="'Укажите через запятую, максимум 3, для исключения добавьте \'-\' в начале. Пример: https://habr.net, habr.com, -test.ru.'"/>
    </div>
    <label for="on_domain_filter">Искать по сайту (опционально)</label>
  </FloatLabel>
</template>

<script setup>
import InputText from 'primevue/inputtext';
import FloatLabel from "primevue/floatlabel";
import {useInputStore} from '@/modules/chat/stores/userInputStore';

const userInput = useInputStore();

const clearInput = () => {
  userInput.searchDomainFilter = '';
};
</script>